import React from "react";
import { useTranslation } from "../../useTranslation";

import GoogleButton from "./GoogleButton";
import FacebookButton from "./FacebookButton";
import "./withSocialProviders.scss";
import AppleButton from "./AppleButton";

interface SocialLoginButtonsProps {
  context: "signIn" | "signUp";
  wrappedProps?: any;
}

const SocialLoginButtonsControl: React.FC<SocialLoginButtonsProps> = ({
  context
}) => {
  const [t] = useTranslation("social");
  return (
    <>
      <GoogleButton
        wrappedProps={{ mb: "between-actions" }}
        id={"google-" + context}
        title={t("google." + context + ".buttonTittle")}
        imgAlt={t("google." + context + ".imgAlt")}
      />
      <FacebookButton
        wrappedProps={{ mb: "between-actions" }}
        id={"facebook-" + context}
        title={t("facebook." + context + ".buttonTittle")}
        imgAlt={t("facebook." + context + ".imgAlt")}
      />
      <AppleButton
        id={`apple-${context}`}
        title={t(`apple.${context}.buttonTittle`)}
        imgAlt={t(`apple.${context}.imgAlt`)}
      />
    </>
  );
};

const SocialLoginButtons: React.FunctionComponent<SocialLoginButtonsProps> = React.memo(
  SocialLoginButtonsControl
);
export default SocialLoginButtons;
